var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 58,
    viewBox: "0 0 51 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2561 24.8959L38.6028 19.3208L25.377 29.2028L38.6025 39.0847L48.2888 33.4905C49.799 32.5729 50.7003 30.9696 50.7003 29.203C50.7003 27.4363 49.7989 25.8331 48.2561 24.8959Z",
    fill: "#FF9100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7213 29.2031C28.7068 29.2217 17.0275 44.2379 17.0181 44.25L1.80392 56.2318C0.867554 55.2955 0.299225 54.0251 0.299225 52.6205V5.70271C0.299225 4.29844 0.867554 3.0277 1.80392 2.09155L17.0181 14.1561C17.0275 14.1682 28.7068 29.1844 28.7213 29.2031Z",
    fill: "#FDE2CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7208 29.2032L25.377 33.5166V24.8896L28.7208 29.2032Z",
    fill: "#FDE2CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6203 19.3053L28.7226 29.203L1.8053 2.09161C2.13956 1.79056 2.47405 1.55649 2.84187 1.32243C4.44676 0.419724 6.35282 0.453051 7.9245 1.42285L25.3789 11.6816L38.6203 19.3053Z",
    fill: "#7FE881"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6185 19.3053L28.7208 29.203L25.377 25.8592V11.6816L38.6185 19.3053Z",
    fill: "#FDE2CD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6203 39.1002L25.3789 46.7241L7.89107 56.9337C7.08856 57.4018 6.21918 57.6693 5.31625 57.6693C4.48031 57.6693 3.64437 57.4352 2.84187 57.0005C2.47405 56.7664 2.13956 56.5325 1.8053 56.2316L28.7226 29.2028L38.6203 39.1002Z",
    fill: "#FF637B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6185 39.1002L25.377 46.7241V32.5465L28.7208 29.2028L38.6185 39.1002Z",
    fill: "#FDE2CD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.09c603852d1b054d954f131c7aab8c8e.svg";
export { ForwardRef as ReactComponent };